import brands from "../brands.json";

const brand = process.env.REACT_APP_BRAND || "M10";

const SMALL_LOGO = require("../assets/images/brand/" +
  brands[brand].images.smallLogo);
const BIG_LOGO = require("../assets/images/brand/" +
  brands[brand].images.bigLogo);
const BIG_LOGO_LIGHT = require("../assets/images/brand/" +
  brands[brand].images.bigLogoLight);

export { SMALL_LOGO, BIG_LOGO, BIG_LOGO_LIGHT };
